export function setSpecialties (state, data) {
  if (data) {
    state.specialties = data
  } else {
    state.specialties = []
  }
}

export function setProfissionaisAgenda (state, data) {
  if (data) {
    state.profissionaisAgenda = data
  } else {
    state.profissionaisAgenda = null
  }
}

export function setLocal (state, data) {
  if (data) {
    state.local = data
  } else {
    state.local = null
  }
}

export function setEndereco (state, data) {
  if (data) {
    state.endereco = data
  } else {
    state.endereco = null
  }
}

export function setProfessionals (state, data) {
  if (data) {
    state.professionals = data
  } else {
    state.professionals = []
  }
}

export function setSchedules (state, data) {
  if (data) {
    state.schedules = data
  } else {
    state.schedules = []
  }
}

export function setSchedulesToAddTime(state, data) {
  if(data) {
    state.schedulesToAddTime = data
  } else {
    // console.log(state)
    state.schedulesToAddTime = null
  }
}

export function setMedicalInsurances (state, data) {
  if (data) {
    state.medicalInsurances = data
  } else {
    state.medicalInsurances = []
  }
}

export function setIndividuals (state, data) {
  if (data) {
    state.individuals = data
  } else {
    state.individuals = null
  }
}

export function setIndividual (state, data){
  if(data) {
    state.individual = data
  } else {
    state.individual = null
  }
}

export function setAgendamentosSgh (state, data) {
  if (data) {
    state.agendamentosSgh = data
  } else {
    state.agendamentosSgh = []
  }
}

export function setStatus (state, data) {
  if (data) {
    state.status = data
  } else {
    state.status = null
  }
}

export function setDatasAgenda (state, data) {
  if (data) {
    state.datasAgenda = data
  } else {
    state.datasAgenda = []
  }
}

export function setLogo (state, data) {
  if (data) {
    state.logo = data
  } else {
    state.logo = null
  }
}

export function setCpfObrigatorio (state, data) {
  if (data) {
    state.cpfObrigatorio = data
  } else {
    state.cpfObrigatorio = null
  }
}

export function setUser (state, data) {
  if (data) {
    state.user = data
  } else {
    state.user = null
  }
}

export function setUserCpfDigital (state, data) {
  if (data) {
    state.userCpfDigital = data
  } else {
    state.userCpfDigital = null
  }
}

export function setPodeIncluirHorarioExtra (state, data) {
  state.podeIncluirHorarioExtra = data === true
}


export function setTelehealth (state, data) {
  // console.log('[MUTATION] sgh/setTelehealth chamado com:', data)
  state.telehealth = data
  state.filter = state.filter || {}
  state.filter.attendance = data === true ? 'telemedicina' : 'presencial'
  // console.log('[MUTATION] sgh/filter.attendance agora:', state.filter.attendance)
}

export function setCities(state, data) {
  if (data) {
    state.cities = data
  } else {
    state.cities = null
  }
}

export function setTipoAgendamentoSgh(state, data) {
    state.tipoAgendamentoSgh = data === true;
}

export function setAppointmentTypes(state, data) {
    state.appointmentTypes = data || [];
}

export function setAppointmentTypeForAgenda(state, { appLid, appointmentType, telehealth }) {
    if (!Array.isArray(state.agendamentosSgh)) return
    for (const grupo of state.agendamentosSgh) {
        const agenda = grupo.agendas && grupo.agendas.find(a => a.appLid === appLid)
        if (agenda) {
            agenda.appointmentType = appointmentType
            // Atualiza o tipo de consulta no item da lista (sem refazer a consulta).
            if (telehealth !== undefined) {
                agenda.telehealth = telehealth
            }
            return
        }
    }
}
